import React, { useEffect, useState } from "react";
import {
    Form,
    Input,
    Select,
    Button,
    Radio,
    Upload,
    Space,
    Typography,
    Divider,
    Tooltip,
    message,
} from "antd";
import {
    InboxOutlined,
    PhoneOutlined,
    LinkOutlined,
    CopyOutlined,
    RollbackOutlined,
    CloseCircleOutlined,
    CommentOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createWabaTemplate, editWabaTemplate } from "../../../../../core/data/redux/slices/WabaTemplateSlice";
import { BoldOutlined, ItalicOutlined, StrikethroughOutlined, CodeOutlined, SmileOutlined } from "@ant-design/icons";
import EmojiPicker from "emoji-picker-react";

import { useSelector } from "react-redux";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const categoryOptions = [
    { label: "Marketing", value: "MARKETING" },
    { label: "Utility", value: "UTILITY" },
    { label: "Authentication", value: "AUTHENTICATION" },
    { label: "Alcoholic Beverages", value: "ALCOHOL" },
    { label: "Clothing and Apparel", value: "APPAREL" },
    { label: "Automotive", value: "AUTO" },
    { label: "Beauty, Spa and Salon", value: "BEAUTY" },
    { label: "Education", value: "EDU" },
    { label: "Entertainment", value: "ENTERTAIN" },
    { label: "Event Planning and Service", value: "EVENT_PLAN" },
    { label: "Finance and Banking", value: "FINANCE" },
    { label: "Public Service", value: "GOVT" },
    { label: "Food and Grocery", value: "GROCERY" },
    { label: "Medical and Health", value: "HEALTH" },
    { label: "Hotel and Lodging", value: "HOTEL" },
    { label: "Non-profit", value: "NONPROFIT" },
    { label: "Online Gambling & Gaming", value: "ONLINE_GAMBLING" },
    { label: "Over-the-Counter Drugs", value: "OTC_DRUGS" },
    { label: "Other", value: "OTHER" },
    { label: "Non-Online Gambling & Gaming (E.g. Brick and mortar)", value: "PHYSICAL_GAMBLING" },
    { label: "Professional Services", value: "PROF_SERVICES" },
    { label: "Restaurant", value: "RESTAURANT" },
    { label: "Shopping and Retail", value: "RETAIL" },
    { label: "Travel and Transportation", value: "TRAVEL" }
];

const languageMap = {
    Afrikaans: "af",
    Albanian: "sq",
    Arabic: "ar",
    "Arabic (EGY)": "ar_EG",
    "Arabic (UAE)": "ar_AE",
    "Arabic (LBN)": "ar_LB",
    "Arabic (MAR)": "ar_MA",
    "Arabic (QAT)": "ar_QA",
    Azerbaijani: "az",
    Belarusian: "be_BY",
    Bengali: "bn",
    "Bengali (IND)": "bn_IN",
    Bulgarian: "bg",
    Catalan: "ca",
    "Chinese (CHN)": "zh_CN",
    "Chinese (HKG)": "zh_HK",
    "Chinese (TAI)": "zh_TW",
    Croatian: "hr",
    Czech: "cs",
    Danish: "da",
    Dari: "prs_AF",
    Dutch: "nl",
    "Dutch (BEL)": "nl_BE",
    English: "en",
    "English (UK)": "en_GB",
    "English (US)": "en_US",
    "English (UAE)": "en_AE",
    "English (AUS)": "en_AU",
    "English (CAN)": "en_CA",
    "English (GHA)": "en_GH",
    "English (IRL)": "en_IE",
    "English (IND)": "en_IN",
    "English (JAM)": "en_JM",
    "English (MYS)": "en_MY",
    "English (NZL)": "en_NZ",
    "English (QAT)": "en_QA",
    "English (SGP)": "en_SG",
    "English (UGA)": "en_UG",
    "English (ZAF)": "en_ZA",
    Estonian: "et",
    Filipino: "fil",
    Finnish: "fi",
    French: "fr",
    "French (BEL)": "fr_BE",
    "French (CAN)": "fr_CA",
    "French (CHE)": "fr_CH",
    "French (CIV)": "fr_CI",
    "French (MAR)": "fr_MA",
    Georgian: "ka",
    German: "de",
    "German (AUT)": "de_AT",
    "German (CHE)": "de_CH",
    Greek: "el",
    Gujarati: "gu",
    Hausa: "ha",
    Hebrew: "he",
    Hindi: "hi",
    Hungarian: "hu",
    Indonesian: "id",
    Irish: "ga",
    Italian: "it",
    Japanese: "ja",
    Kannada: "kn",
    Kazakh: "kk",
    Kinyarwanda: "rw_RW",
    Korean: "ko",
    "Kyrgyz (Kyrgyzstan)": "ky_KG",
    Lao: "lo",
    Latvian: "lv",
    Lithuanian: "lt",
    Macedonian: "mk",
    Malay: "ms",
    Malayalam: "ml",
    Marathi: "mr",
    Norwegian: "nb",
    Pashto: "ps_AF",
    Persian: "fa",
    Polish: "pl",
    "Portuguese (BR)": "pt_BR",
    "Portuguese (POR)": "pt_PT",
    Punjabi: "pa",
    Romanian: "ro",
    Russian: "ru",
    Serbian: "sr",
    Sinhala: "si_LK",
    Slovak: "sk",
    Slovenian: "sl",
    Spanish: "es",
    "Spanish (ARG)": "es_AR",
    "Spanish (CHL)": "es_CL",
    "Spanish (COL)": "es_CO",
    "Spanish (CRI)": "es_CR",
    "Spanish (DOM)": "es_DO",
    "Spanish (ECU)": "es_EC",
    "Spanish (HND)": "es_HN",
    "Spanish (MEX)": "es_MX",
    "Spanish (PAN)": "es_PA",
    "Spanish (PER)": "es_PE",
    "Spanish (SPA)": "es_ES",
    "Spanish (URY)": "es_UY",
    Swahili: "sw",
    Swedish: "sv",
    Tamil: "ta",
    Telugu: "te",
    Thai: "th",
    Turkish: "tr",
    Ukrainian: "uk",
    Urdu: "ur",
    Uzbek: "uz",
    Vietnamese: "vi",
    Zulu: "zu",
};


const MAX_COUNTS = {
    call: 1,
    url: 2,
    quickReply: 10,
    copyCode: 1,
};

const NAMED_PARAMS = [
  { label: "First Name",    value: "first_name" },
  { label: "Last Name",     value: "last_name" },
  { label: "Phone",         value: "phone" },
  { label: "Email",         value: "email" },
  { label: "Company Name",  value: "company_name" },
];

const WabaAddTemplate = () => {
    const location = useLocation();

    const selectedTemplate =
        location.state?.record || null;
    const isEditMode = Boolean(selectedTemplate?._id);
    const [headerImage, setHeaderImage] = useState(null);

    const [name, setName] = useState(selectedTemplate?.name || "");
    const [category, setCategory] = useState(
        selectedTemplate?.category || "MARKETING"
    );
// const bodyRef = React.useRef(null);
const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const userProfile = useSelector((state) => state.profile);

    const isWhatsappConnected =
        userProfile?.accounts?.whatsapp?.isConnected;

    const [language, setLanguage] = useState(selectedTemplate?.language || "en_US");

    const [headerType, setHeaderType] = useState("Text");
    const [headerText, setHeaderText] = useState("");
    const [body, setBody] = useState("");
    const [footer, setFooter] = useState("");
const bodyRef = React.useRef(null);



    const [headerMediaFile, setHeaderMediaFile] = useState(null);
    const [headerMediaPreview, setHeaderMediaPreview] = useState(null);
    const [buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    const navigate = useNavigate();

const wrapSelection = (before, after = before) => {
    const textarea = bodyRef.current?.resizableTextArea?.textArea;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selected = body.substring(start, end);

    const newText =
        body.substring(0, start) +
        before +
        selected +
        after +
        body.substring(end);

    setBody(newText);

    // restore cursor
    setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = start + before.length;
        textarea.selectionEnd = end + before.length;
    }, 0);
};
const insertAtCursor = (text) => {
    const textarea = bodyRef.current?.resizableTextArea?.textArea;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
        body.substring(0, start) +
        text +
        body.substring(end);

    setBody(newText);

    // Restore cursor position after inserted emoji
    setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = textarea.selectionEnd =
            start + text.length;
    }, 0);
};
const onEmojiClick = (emojiData) => {
    insertAtCursor(emojiData.emoji);
    setShowEmojiPicker(false);
};

    useEffect(() => {
        if (!selectedTemplate) return;

        const hydratedButtons = [];

        selectedTemplate.components?.forEach((comp) => {
            /* ---------- HEADER ---------- */
            if (comp.type === "HEADER") {
                if (comp.text) {
                    setHeaderType("Text");
                    setHeaderText(comp.text);
                }
                else if (comp.format) {
                    const normalizedFormat =
                        comp.format.charAt(0) + comp.format.slice(1).toLowerCase();

                    setHeaderType(normalizedFormat); // Image / Video / Document

                    // 🔥 THIS IS THE MISSING PIECE
                    if (comp.media?.s3Url) {
                        setHeaderMediaPreview(comp.media.s3Url);
                    }
                }
            }

            /* ---------- BODY ---------- */
            if (comp.type === "BODY") {
                setBody(comp.text || "");
            }

            /* ---------- FOOTER ---------- */
            if (comp.type === "FOOTER") {
                setFooter(comp.text || "");
            }

            /* ---------- BUTTONS ---------- */
            if (comp.type === "BUTTONS") {
                comp.buttons.forEach((btn) => {
                    switch (btn.type) {
                        case "PHONE_NUMBER": {
                            const stripped = (btn.phone_number || "").replace(/^\+/, "");
                            hydratedButtons.push({
                                id: Date.now() + Math.random(),
                                type: "call",
                                text: btn.text,
                                country: stripped.slice(0, 3) || "",
                                phone: stripped.slice(3) || "",
                            });
                            break;
                        }

                        case "URL":
                            hydratedButtons.push({
                                id: Date.now() + Math.random(),
                                type: "url",
                                text: btn.text,
                                url: btn.url,
                            });
                            break;

                        case "COPY_CODE":
                            hydratedButtons.push({
                                id: Date.now() + Math.random(),
                                type: "copy",
                                text: btn.text || "Copy Code",
                                code: btn.example || "",
                            });
                            break;

                        case "QUICK_REPLY":
                            hydratedButtons.push({
                                id: Date.now() + Math.random(),
                                type: "quick",
                                text: btn.text,
                            });
                            break;

                        default:
                            break;
                    }
                });
            }
        });

        setButtons(hydratedButtons);
    }, [selectedTemplate]);

    const handleSaveTemplate = async () => {
        try {
            setLoading(true);

            const emptyCopyCode = buttons.find(b => b.type === "copy" && !b.code?.trim());
            if (emptyCopyCode) {
                message.error("Please enter a coupon code for the Copy Code button.");
                setLoading(false);
                return;
            }

            const components = [];

            if (headerType === "Text") {
                components.push({
                    type: "HEADER",
                    format: "TEXT",
                    text: headerText || "Header",
                });
            } else if (["Image", "Video", "Document"].includes(headerType)) {
                components.push({
                    type: "HEADER",
                    format: headerType.toUpperCase(),
                });
            }

            components.push({
                type: "BODY",
                text: body || "Body content here",
            });

            if (footer) {
                components.push({
                    type: "FOOTER",
                    text: footer,
                });
            }


            if (buttons.length > 0) {
                const formattedButtons = buttons
                    .map((b) => {
                        switch (b.type) {
                            case "call":
                                return {
                                    type: "PHONE_NUMBER",
                                    text: b.text,
                                    phone_number: `+${b.country}${b.phone}`.replace(/^\++/, "+"),
                                };
                            case "url":
                                return { type: "URL", text: b.text, url: b.url };
                            case "copy":
                                return { type: "COPY_CODE", ...(b.code ? { example: b.code } : {}) };
                            case "quick":
                                return { type: "QUICK_REPLY", text: b.text };
                            default:
                                return null;
                        }
                    })
                    .filter(Boolean);

                if (formattedButtons.length) {
                    components.push({
                        type: "BUTTONS",
                        buttons: formattedButtons,
                    });
                }
            }

            // FormData
            const formData = new FormData();
            formData.append("name", name);
            formData.append("language", languageMap[language] || "en_US");
            formData.append("category", category.toUpperCase() || "UTILITY");
            formData.append("parameter_format", "named");
            formData.append("components", JSON.stringify(components));
            if (selectedTemplate?._id) {
                formData.append("templateId", selectedTemplate?._id);
            }
            if (["Image", "Video", "Document"].includes(headerType) && headerMediaFile) {

                if (selectedTemplate?._id) {
                    formData.append("file", headerMediaFile);
                }
                else {
                    formData.append("media_url", headerMediaFile);
                }
                formData.append("header_format", headerType.toUpperCase());
            }

            // Log FormData for debugging
            console.log("FormData to be sent:");
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            if (selectedTemplate?._id) {

                console.log(formData,"formData")
              const response = await dispatch(editWabaTemplate(formData)).unwrap();

              
            } else {
                const response = await dispatch(createWabaTemplate(formData)).unwrap();
            }


            setLoading(false);
            navigate(-1);
        } catch (error) {
            console.error("Failed to create template", error);
            setLoading(false);
        }
    };

    const callCount = buttons.filter(b => b.type === "call").length;
    const urlCount = buttons.filter(b => b.type === "url").length;
    const copyCount = buttons.filter(b => b.type === "copy").length;
    const quickCount = buttons.filter(b => b.type === "quick").length;



    const handleHeaderMediaChange = (info) => {
        const file = info.file;

        if (!file) return;

        // 1️⃣ Save File for API upload
        setHeaderMediaFile(file);

        // 2️⃣ Create preview URL (image / video)
        const previewUrl = URL.createObjectURL(file);
        setHeaderMediaPreview(previewUrl);

        // 3️⃣ For document preview (show filename)
        if (headerType === "Document") {
            setHeaderMediaPreview(file.name);
        }
    };

    const removeButton = (id) => {
        setButtons(prev => prev.filter(b => b.id !== id));
    };
    const updateButton = (id, field, value) => {
        setButtons(prev =>
            prev.map(b =>
                b.id === id ? { ...b, [field]: value } : b
            )
        );
    };
    const addCallButton = () => {
        setButtons(prev => [
            ...prev,
            {
                id: Date.now(),
                type: "call",
                text: "Call",
                country: "971",
                phone: ""
            }
        ]);
    };

    const addUrlButton = () => {
        setButtons(prev => [
            ...prev,
            {
                id: Date.now(),
                type: "url",
                text: "Goto Website",
                url: ""
            }
        ]);
    };

    const addCopyCodeButton = () => {
        setButtons(prev => [
            ...prev,
            {
                id: Date.now(),
                type: "copy",
                text: "Copy Code",
                code: ""
            }
        ]);
    };

    const addQuickReplyButton = () => {
        setButtons(prev => [
            ...prev,
            {
                id: Date.now(),
                type: "quick",
                text: "Reply"
            }
        ]);
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                {isWhatsappConnected === false ? (

                    <div
                        style={{
                            height: "70vh",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        <h3>WhatsApp is not connected</h3>
                        <p style={{ color: "#888", marginBottom: 20 }}>
                            Please configure WhatsApp to start chatting.
                        </p>

                       <button
              className="btn btn-primary"
              onClick={() => {
                if (userProfile?.role === "companyAdmin") {
                  navigate("/whatsapp/setting");
                } else if (userProfile?.role === "superadmin") {
                  navigate("/admin/whatsapp/setting");
                }
              }}
              disabled={userProfile?.role !== "companyAdmin" && userProfile?.role !== "superadmin"}
            >
              {userProfile?.role === "companyAdmin" || userProfile?.role === "superadmin"
                ? "Go to WhatsApp Settings"
                : "Contact your Company Admin"}
            </button>
                    </div>

                ) :
                    <>
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col-sm-12">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="page-header mb-0">
                                                <div className="row align-items-center">
                                                    <h4 className="page-title mb-0">
                                                        <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                                                            <i className="ti ti-arrow-narrow-left me-3" />
                                                        </span>
                                                        {isEditMode ? "Edit Template" : "Add Template"}
                                                    </h4>

                                                </div>
                                            </div>
                                            <div>
                                                <Button type="primary" onClick={handleSaveTemplate} loading={loading}>
                                                    {isEditMode ? "Update Template" : "Save Template"}
                                                </Button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: 24,
                                padding: 24,
                                backgroundColor: "#f0f2f5",
                                height: "90vh",
                                overflow: "hidden",
                            }}
                        >
                            {/* Left scrollable form */}
                            <div
                                style={{
                                    flex: 1,
                                    // maxWidth: 600,
                                    background: "white",
                                    padding: 24,
                                    borderRadius: 8,
                                    overflowY: "auto",
                                    height: "calc(100vh - 200px)",
                                }}
                            >


                                <Form layout="vertical" autoComplete="off">
                                    <Form.Item label="Name">
                                        <Input value={name} onChange={(e) => setName(e.target.value)} disabled={isEditMode} />
                                    </Form.Item>

                                    <Form.Item label="Category">
                                        <Select
                                            value={category}
                                            onChange={(value) => setCategory(value)}
                                            options={categoryOptions}
                                            showSearch
                                        />

                                    </Form.Item>

                                    <Form.Item label="Language">
                                        <Select
                                            placeholder="Select Language"
                                            value={language}
                                            onChange={setLanguage}
                                            showSearch
                                            // disabled={isEditMode}
                                            allowClear
                                        >
                                            {Object.entries(languageMap).map(([name, code]) => (
                                                <Option key={code} value={code}>
                                                    {name}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>


                                    <Divider>Header (Optional)</Divider>
                                    <Form.Item label="Header Type">
                                        <Radio.Group
                                            onChange={(e) => {
                                                setHeaderType(e.target.value);
                                                if (e.target.value !== "Image") setHeaderImage(null);
                                            }}
                                            value={headerType}
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value="Text">Text</Radio.Button>
                                            <Radio.Button value="Image">Image</Radio.Button>
                                            <Radio.Button value="Video">Video</Radio.Button>
                                            <Radio.Button value="Document">Document</Radio.Button>
                                        </Radio.Group>
                                    </Form.Item>
                                    {headerType === "Text" && (
                                        <Form.Item label="Header Text">
                                            <Input
                                                maxLength={60}
                                                showCount
                                                value={headerText}
                                                onChange={(e) => setHeaderText(e.target.value)}
                                                placeholder="Enter header text"
                                            />
                                        </Form.Item>
                                    )}


                                    {["Image", "Video", "Document"].includes(headerType) && (
                                        <Form.Item>
                                            <Upload
                                                beforeUpload={() => false}
                                                showUploadList={false}
                                                maxCount={1}
                                                onChange={handleHeaderMediaChange}
                                                accept={
                                                    headerType === "Image"
                                                        ? "image/*"
                                                        : headerType === "Video"
                                                            ? "video/*"
                                                            : ".pdf,.doc,.docx"
                                                }
                                            >
                                                <Button icon={<InboxOutlined />}>
                                                    Upload {headerType}
                                                </Button>
                                            </Upload>
                                        </Form.Item>
                                    )}

                                    <Divider>Body (Required)</Divider>
                                    {/* <Form.Item label="Body Text">
                                        <TextArea
                                            rows={4}
                                            maxLength={1098}
                                            showCount
                                            value={body}
                                            onChange={(e) => setBody(e.target.value)}
                                            placeholder="Enter the message body"
                                        />
                                    </Form.Item> */}
                                    <Form.Item label="Body Text">

    {/* Formatting Toolbar */}
    <Space style={{ marginBottom: 8 }}>
        <Tooltip title="Bold">
            <Button icon={<BoldOutlined />} onClick={() => wrapSelection("*")} />
        </Tooltip>

        <Tooltip title="Italic">
            <Button icon={<ItalicOutlined />} onClick={() => wrapSelection("_")} />
        </Tooltip>

        <Tooltip title="Strikethrough">
            <Button icon={<StrikethroughOutlined />} onClick={() => wrapSelection("~")} />
        </Tooltip>

        <Tooltip title="Monospace">
            <Button icon={<CodeOutlined />} onClick={() => wrapSelection("```", "```")} />
        </Tooltip>

        <Select
            placeholder="Insert Variable"
            style={{ width: 160 }}
            size="small"
            value={null}
            onChange={(paramName) => {
                insertAtCursor(`{{${paramName}}}`);
            }}
            options={NAMED_PARAMS.map(p => ({ label: p.label, value: p.value }))}
        />

        <Tooltip title="Emoji">
    <Button
        icon={<SmileOutlined />}
        onClick={() => setShowEmojiPicker(prev => !prev)}
    />
</Tooltip>
{showEmojiPicker && (
    <div style={{ position: "absolute", zIndex: 1000 }}>
        <EmojiPicker onEmojiClick={onEmojiClick} />
    </div>
)}

    </Space>

    <TextArea
        ref={bodyRef}
        rows={6}
        maxLength={1024}
        showCount
        value={body}
        onChange={(e) => setBody(e.target.value)}
        placeholder="Enter the message body"
    />
</Form.Item>


                                    <Divider>Footer Description (Optional)</Divider>
                                    <Form.Item label="Footer Text">
                                        <TextArea
                                            rows={2}
                                            maxLength={60}
                                            showCount
                                            value={footer}
                                            onChange={(e) => setFooter(e.target.value)}
                                            placeholder="Footer goes here"
                                        />
                                    </Form.Item>

                                    <Divider>Buttons (Add buttons by clicking below)</Divider>

                                    <Space direction="vertical" style={{ width: "100%", marginBottom: 16 }}>
                                        {/* Add Buttons */}
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "1fr 1fr", // 2 columns
                                                columnGap: "12px",
                                                rowGap: "12px",
                                                width: "100%",
                                            }}
                                        >
                                            {/* Call Button */}
                                            <Tooltip
                                                title={
                                                    callCount >= MAX_COUNTS.call
                                                        ? "Maximum 1 Call Button allowed"
                                                        : "Add Call Phone Button"
                                                }
                                            >
                                                <Button
                                                    type="primary"
                                                    onClick={addCallButton}
                                                    disabled={callCount >= MAX_COUNTS.call || buttons.length >= 10}
                                                >
                                                    Add Call Phone Number ({MAX_COUNTS.call - callCount} left)
                                                </Button>

                                            </Tooltip>

                                            {/* Website Button */}
                                            <Tooltip
                                                title={
                                                    urlCount >= MAX_COUNTS.url
                                                        ? "Maximum 2 Website Buttons allowed"
                                                        : "Add Website Button"
                                                }
                                            >
                                                <Button
                                                    type="primary"
                                                    onClick={addUrlButton}
                                                    disabled={urlCount >= MAX_COUNTS.url || buttons.length >= 10}
                                                >
                                                    Add Website Button ({MAX_COUNTS.url - urlCount} left)
                                                </Button>

                                            </Tooltip>

                                            {/* Copy Code Button */}
                                            <Tooltip
                                                title={
                                                    copyCount >= MAX_COUNTS.copyCode
                                                        ? "Only 1 Copy Code Button allowed"
                                                        : "Add Copy Code Button"
                                                }
                                            >
                                                <Button
                                                    type="primary"
                                                    onClick={addCopyCodeButton}
                                                    disabled={copyCount >= MAX_COUNTS.copyCode || buttons.length >= 10}
                                                >
                                                    Add Copy Code Button ({MAX_COUNTS.copyCode - copyCount} left)
                                                </Button>

                                            </Tooltip>

                                            {/* Quick Reply Button */}
                                            <Tooltip
                                                title={
                                                    quickCount >= MAX_COUNTS.quickReply
                                                        ? "Maximum 10 Quick Reply Buttons allowed"
                                                        : "Add Quick Reply Button"
                                                }
                                            >
                                                <Button
                                                    type="primary"
                                                    onClick={addQuickReplyButton}
                                                    disabled={quickCount >= MAX_COUNTS.quickReply || buttons.length >= 10}
                                                >
                                                    Add Quick Reply Button ({MAX_COUNTS.quickReply - quickCount} left)
                                                </Button>

                                            </Tooltip>
                                        </div>

                                        {buttons.map((btn) => {
                                            if (btn.type === "call") {
                                                return (
                                                    <div key={btn.id} style={{ marginBottom: 14, backgroundColor: "#f0f2f5", padding: 10, borderRadius: 10 }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-2"><div>Phone Number</div>
                                                            <CloseCircleOutlined
                                                                onClick={() => removeButton(btn.id)}
                                                                style={{ color: "red", cursor: "pointer" }}
                                                            />
                                                        </div>

                                                        <Input
                                                            value={btn.text}
                                                            placeholder="Button Text"
                                                            onChange={(e) => updateButton(btn.id, "text", e.target.value)}
                                                            className="mb-2"
                                                        />

                                                        <Input
                                                            value={btn.country}
                                                            placeholder="Country Code"
                                                            onChange={(e) => updateButton(btn.id, "country", e.target.value)}
                                                            className="mb-2"
                                                        />

                                                        <Input
                                                            value={btn.phone}
                                                            placeholder="Phone Number"
                                                            onChange={(e) => updateButton(btn.id, "phone", e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (btn.type === "url") {
                                                return (
                                                    <div key={btn.id} style={{ marginBottom: 14, backgroundColor: "#f0f2f5", padding: 10, borderRadius: 10 }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-2"><div>URL</div>
                                                            <CloseCircleOutlined
                                                                onClick={() => removeButton(btn.id)}
                                                                style={{ color: "red", cursor: "pointer" }}
                                                            />
                                                        </div>

                                                        <Input
                                                            value={btn.text}
                                                            placeholder="Button Text"
                                                            onChange={(e) => updateButton(btn.id, "text", e.target.value)}
                                                            className="mb-2"
                                                        />

                                                        <Input
                                                            value={btn.url}
                                                            placeholder="https://example.com"
                                                            onChange={(e) => updateButton(btn.id, "url", e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (btn.type === "copy") {
                                                return (
                                                    <div key={btn.id} style={{ marginBottom: 14, backgroundColor: "#f0f2f5", padding: 10, borderRadius: 10 }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-2"><div>Copy Code</div>
                                                            <CloseCircleOutlined
                                                                onClick={() => removeButton(btn.id)}
                                                                style={{ color: "red", cursor: "pointer" }}
                                                            />
                                                        </div>

                                                        <Input
                                                            value={btn.text}
                                                            onChange={(e) => updateButton(btn.id, "text", e.target.value)}
                                                            placeholder="Button Text"
                                                            className="mb-2"
                                                        />

                                                        <Input
                                                            value={btn.code}
                                                            onChange={(e) => updateButton(btn.id, "code", e.target.value)}
                                                            placeholder="Sample code for Meta review, e.g. DISCOUNT10"
                                                        />
                                                    </div>
                                                );
                                            }

                                            if (btn.type === "quick") {
                                                return (
                                                    <div key={btn.id} style={{ marginBottom: 14, backgroundColor: "#f0f2f5", padding: 10, borderRadius: 10 }}>
                                                        <div className="d-flex justify-content-between align-items-center mb-2"><div>Quick Reply</div>
                                                            <CloseCircleOutlined
                                                                onClick={() => removeButton(btn.id)}
                                                                style={{ color: "red", cursor: "pointer" }}
                                                            />
                                                        </div>
                                                        <Input
                                                            value={btn.text}
                                                            placeholder="Button Text"
                                                            onChange={(e) => updateButton(btn.id, "text", e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            }

                                            return null;
                                        })}

                                    </Space>
                                </Form>
                            </div>

                            {/* Right Preview section */}
                            <div
                                style={{
                                    flex: 1,
                                    // maxWidth: 400,
                                    // background: "#f9f9f9",
                                    padding: 24,
                                    borderRadius: 8,
                                    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                                    position: "relative",
                                    overflowY: "auto",
                                    height: "calc(100vh - 200px)",
                                    backgroundImage: `url("/assets/img/wabaBg.png")`
                                }}
                            >
                                <Title level={4}>Template Preview</Title>
                                <div
                                    style={{
                                        border: "1px solid #ddd",
                                        borderRadius: 8,
                                        background: "white",
                                        padding: 16,
                                    }}
                                >
                                    {/* Header TEXT */}
                                    {headerType === "Text" && headerText && (
                                        <div style={{ fontWeight: "900", marginBottom: 12 }}>
                                            {headerText}
                                        </div>
                                    )}

                                    {/* Header IMAGE */}
                                    {headerType === "Image" && (
                                        <div style={{ marginBottom: 12 }}>
                                            {headerMediaPreview ? (
                                                <img
                                                    src={headerMediaPreview}
                                                    alt="Header"
                                                    style={{ width: "100%", borderRadius: 8 }}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        height: 150,
                                                        background: "#eee",
                                                        borderRadius: 8,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#888",
                                                    }}
                                                >
                                                    Image Preview
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* Header VIDEO */}
                                    {headerType === "Video" && headerMediaPreview && (
                                        <video
                                            src={headerMediaPreview}
                                            controls
                                            style={{ width: "100%", borderRadius: 8, marginBottom: 12 }}
                                        />
                                    )}

                                    {/* Header DOCUMENT */}
                                    {headerType === "Document" && (
                                        <div
                                            style={{
                                                padding: 12,
                                                border: "1px solid #ddd",
                                                borderRadius: 8,
                                                marginBottom: 12,
                                                textAlign: "center",
                                                color: "#555",
                                            }}
                                        >
                                            📄 {headerMediaPreview || "Document attached"}
                                        </div>
                                    )}

                                    {/* Body */}
                                    {/* <div style={{ fontWeight: "500", marginBottom: 6 }}>
                                        {body}
                                    </div> */}
                                    <div
    dangerouslySetInnerHTML={{
        __html: body
            .replace(/\*(.*?)\*/g, "<b>$1</b>")
            .replace(/_(.*?)_/g, "<i>$1</i>")
            .replace(/~(.*?)~/g, "<s>$1</s>")
            .replace(/```(.*?)```/g, "<code>$1</code>")
            .replace(/\n/g, "<br/>")
    }}
/>


                                    {/* Footer */}
                                    {footer && (
                                        <div style={{ color: "#888", fontSize: 12, marginBottom: 8 }}>
                                            {footer}
                                        </div>
                                    )}

                                    {/* Buttons preview */}
                                    <Space direction="vertical" style={{ width: "100%" }}>
                                        {buttons.map((btn) => (
                                            <Button
                                                key={btn.id}
                                                block
                                                icon={
                                                    btn.type === "call" ? <PhoneOutlined /> :
                                                        btn.type === "url" ? <LinkOutlined /> :
                                                            btn.type === "copy" ? <CopyOutlined /> :
                                                                <CommentOutlined />
                                                }
                                            >
                                                {btn.text}
                                            </Button>
                                        ))}
                                    </Space>
                                </div>

                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default WabaAddTemplate;